export default {
  header: {
    login: 'Log in',
  },
  auth: {
    user: 'User',
    loggingIn: 'Logging in...',
    logout: 'Log out',
    loggingOut: 'Logging out...',
  },
  home: {
    welcome: 'Welcome to Blinqx API Portal',
    subtitle: 'This is a blank page ready for development',
  },
  apiFilter: {
    title: 'Filters',
    searchPlaceholder: 'Search for API name, description',
    deleteFilters: 'Delete filters',
    company: 'Company',
    category: 'Category',
    apiAccess: 'API Access',
    access: {
      private: 'Private',
      public: 'Public',
    },
  },
  apiPortalContent: {
    title: 'Get started with everything you need to build powerful integrations.',
    description:
      "Browse our available APIs, complete with documentation, authentication details, and examples. Whether you're building custom apps, automating tasks, or embedding our services, our APIs are secure, flexible, and easy to use.",
  },
  apiCard: {
    containingFeatures: 'Containing features:',
    seeAllFeatures: 'See all features ({{count}})',
  },
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    noResults: 'No results found',
    apis: 'APIs',
    back: 'Back',
    backToArticles: 'Back to articles list',
  },
  projectCard: {
    fallbackTitle: 'API Project',
    noDescription: 'No description available',
    detailsTitle: 'Details',
    slaTitle: 'SLA',
    contactsTitle: 'Contacts',
  },
  apiDetail: {
    fallbackTitle: 'API Details',
    notFound: 'API definition not found',
    loadError: 'The API definition could not be loaded. Please try again or go back to the',
    notFoundMessage:
      'The requested API definition was not found. Please check the URL or go back to the',
    mainPage: 'main page',
    tabs: {
      features: 'Features',
      guides: 'Documentation articles',
      specs: 'Specs',
      demo: 'Demo',
    },
    specsTab: {
      title: 'API Specification',
      loadingError: 'Unable to load the API specification. Please try again later.',
      noSpecAvailable: 'No API specification available',
      noSpecMessage: 'The API specification is not available for this API.',
      apiIdRequired: 'API ID is required',
      failedToLoad: 'Failed to load API specification',
    },
    guidesTab: {
      noArticles: 'No articles available.',
    },
    featuresTab: {
      noFeatures: 'No features available for this API.',
    },
  },
  footer: {
    stayInLoop: 'Stay in the loop!',
    description:
      'Want to stay up-to-date on all Blinqx developments? Subscribe to our newsletter and follow us on social media!',
    companyInfo: {
      name: 'BLINQX',
      address: 'Pesetastraat 46',
      city: '2991 XT Barendrecht',
      email: 'hello@blinqx.tech',
      kvk: 'KvK 84045132',
    },
    newsletter: {
      title: 'Subscribe to our newsletter',
      agreement: 'By leaving your details here you agree to our',
      termsAndConditions: 'terms and conditions',
      firstNamePlaceholder: 'First name',
      lastNamePlaceholder: 'Last name',
      emailPlaceholder: 'Email address',
      sendButton: 'Send',
    },
    links: {
      aboutUs: 'About us',
      sectors: 'Sectors',
      insights: 'Insights',
      vacancies: 'Vacancies',
    },
    legal: {
      copyright: '2025 all rights reserved',
      terms: 'General Terms and Conditions',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Statement',
      whistleblower: 'Whistleblower Scheme',
    },
  },
  featureDemo: {
    featureNotFound: 'Feature not found',
  },
  errors: {
    failedToFetchApiData: 'Failed to fetch API data',
    failedToFetchApiDefinition: 'Failed to fetch API definition',
  },
} as const;
